
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: {},
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop({ default: {} }) private landingInfo!: any
  
  /// data
  private data: Object = {}
  
  /// provide data
  @Provide() provideData: Object = {}
  
  // computed
  private get infos(): Array<any> {
      return Array<any>()
  }
  
  /// lifecycle
  created() {
    
  }
  
  mounted() {
    
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
    
  }
}
